<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<Accountset></Accountset>
				<div class="ttshop_accountright">
					<div class="ttshop_accounuser">
						<div class="ttshop_accountop">
							<div class="ttshop_accountopcon">
								<el-upload class="avatar-uploader" action="String" :show-file-list="false" :before-upload="beforeAvatarUpload"
								 :http-request="UploadImage">
									<img class="img-default avatar" v-if="imageUrl" :src="imageUrl">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<p>点击编辑头像</p>
							</div>
						</div>
						<div class="ttshop_accounbut">
							<ul>
								<li class="clearfloat">
									<span>昵称：</span>
									<input type="text" v-model="nickname" placeholder="请输入您的昵称" class="ttshop_nc">
								</li>
								<!-- <li class="clearfloat">
									<span>性别：</span>
									<div class="ttshop_accounredio">
										<el-radio-group v-model="radio">
										    <el-radio :label="3">男</el-radio>
										    <el-radio :label="6">女</el-radio>
										    <el-radio :label="9">保密</el-radio>
										  </el-radio-group>
									</div>
								</li> -->
								<li class="clearfloat">
									<span>手机：</span>
									<input type="text" :value="binding" readonly="readonly" class="ttshop_accounzd">
								</li>
								<!-- <li class="clearfloat">
									<span>手机：</span>
									<input type="text" value="1523****892.qq.com" readonly="readonly" class="ttshop_accounzd">
								</li> -->
								<!-- <li class="clearfloat">
									<span>出生日期：</span>
									<div class="ttshop_accountime">
										<el-date-picker v-model="value1"   type="date"   placeholder="选择日期">
										</el-date-picker>
									</div>
								</li> -->
								<li class="clearfloat">
									<button @click="submitBtn">保存</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Accountset from "./components/accountset";
	export default {
		components: {
			Header,
			Userheader,
			Accountset,
			Foot,
		},
		data() {
			return {
				imageUrl: "",
				nickname: "",
				binding: "",
				radio: 3,
				value1: "",
			};
		},
		mounted() {
			let user = this.$store.state.user;
			let binding = user.binding;
			this.binding = binding.substr(0,3) + "****" + binding.substr(7);
			this.imageUrl = user.avatar_url;
			this.nickname = user.nickname;
		},
		methods: {
			beforeAvatarUpload(file) {
				// const isJPG = file.type === "image/jpeg";
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				//   this.$message({
				//     type: "error",
				//     message: "上传头像图片只能是 JPG 格式!",
				//     showClose: true,
				//     offset: 200,
				//     duration: 1000,
				//   });
				//   // this.$message.error("上传头像图片只能是 JPG 格式!");
				// }
				if (!isLt2M) {
					this.$message({
						type: "error",
						message: "上传头像图片大小不能超过 2MB!",
						showClose: true,
						offset: 200,
						duration: 1000,
					});
					// this.$message.error("上传头像图片大小不能超过 2MB!");
				}
				return isLt2M;
			},
			// 图片上传
			UploadImage(param) {
				console.log(param);
				const formData = new FormData();
				formData.append("image", param.file);
				let config = {
					headers: {
						"Content-Type": "mutipart/form-data"
					},
				};
				this.$api
					.uploadImage(formData, config)
					.then((res) => {
						console.log(res);
						this.imageUrl = res.data.url;
					})
					.catch((err) => {
						console.log(err);
						// this.user = err;
						this.$message({
							type: "error",
							message: err.msg,
							showClose: true,
							offset: 200,
							duration: 1000,
						});
					});
			},
			// 保存
			submitBtn() {
				let _this = this;
				let user = _this.$store.state.user;
				if (
					user.avatar_url != _this.imageUrl ||
					_this.nickname != user.nickname
				) {
					this.$api
						.userSave({
							nickname: _this.nickname,
							head_portrait: _this.imageUrl,
						})
						.then((res) => {
							if (res.code == 0) {
								user.nickname = _this.nickname;
								user.avatar_url = _this.imageUrl;
								this.$store.commit("userInfo", user);
								this.$message({
									type: "success",
									message: res.msg,
									showClose: true,
									offset: 200,
									duration: 1000,
								});
							}
						})
						.catch((err) => {
							console.log(err);
							// this.user = err;
							this.$message({
								type: "error",
								message: err.msg,
								showClose: true,
								offset: 200,
								duration: 1000,
							});
						});
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.ttshop_accountright {
		float: right;
		width: 990px;
		min-height: 537px;
		background: #fff;

		.ttshop_accounuser {
			width: 100%;
			padding: 55px;
			box-sizing: border-box;

			.ttshop_accountop {
				width: 100%;
				padding-bottom: 32px;
				box-sizing: border-box;
				border-bottom: 1px solid #ebebeb;

				.ttshop_accountopcon {
					width: 100px;
					margin-left: 70px;

					.avatar-uploader .el-upload {
						border: 1px dashed #d9d9d9;
						border-radius: 6px;
						cursor: pointer;
						position: relative;
						overflow: hidden;
					}

					.avatar-uploader-icon {
						width: 100px;
						height: 100px;
						background: #ccc;
						color: #ccc;
						border-radius: 50%;
					}

					.avatar {
						width: 100px;
						height: 100px;
						border-radius: 50%;
						display: block;
						object-fit: cover;
					}

					p {
						text-align: center;
						font-size: 12px;
						color: #333;
						padding-top: 12px;
						box-sizing: border-box;
					}
				}
			}

			.ttshop_accounbut {
				width: 100%;
				padding-top: 32px;
				box-sizing: border-box;

				ul {
					li {
						margin-bottom: 12px;

						span {
							float: left;
							width: 80px;
							text-align: right;
							font-size: 12px;
							color: #333;
							margin-right: 16px;
							line-height: 32px;
						}

						.ttshop_nc {
							float: left;
							width: 246px;
							height: 32px;
							border: 1px solid #ebebeb;
							font-size: 12px;
							color: #333;
							border-radius: 2px;
							padding: 0 12px;
							box-sizing: border-box;
						}

						.ttshop_accounredio {
							float: left;
							height: 32px;
							line-height: 32px;
						}

						.ttshop_accounzd {
							float: left;
							width: 246px;
							height: 32px;
							border: 1px solid #ebebeb;
							background: #f2f2f2;
							font-size: 12px;
							color: #333;
							border-radius: 2px;
							padding: 0 12px;
							box-sizing: border-box;
						}

						.ttshop_accountime {
							float: left;

							.el-date-editor.el-input {
								width: 246px;
								height: 32px;
							}
						}

						button {
							float: left;
							margin-left: 96px;
							width: 246px;
							height: 32px;
							margin-top: 20px;
							background: linear-gradient(90deg, #ff9010, #ff0e25);
							background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
							background: -webkit-gradient(90deg, #ff9010, #ff0e25);
							background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
							filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
							font-size: 14px;
							color: #fff;
							border: 0;
							border-radius: 2px;
							cursor: pointer;
							outline: none;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							opacity: 0.8;

							&:hover {
								opacity: 1;
								box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
							}
						}
					}
				}
			}
		}
	}
</style>
